export var ErrorCodeCategory;
(function (ErrorCodeCategory) {
    ErrorCodeCategory["accessDenied"] = "kAccessDenied";
    ErrorCodeCategory["notLoggedIn"] = "kNotLoggedIn";
    ErrorCodeCategory["validationError"] = "kValidationError";
})(ErrorCodeCategory || (ErrorCodeCategory = {}));
export var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED_INVALID_CREDENTIALS"] = "iam.accessDenied.invalidCredentials";
    ErrorCode["ACCESS_DENIED_INVALID_TOKEN"] = "mom.accessDenied.invalidToken";
    ErrorCode["ACCESS_DENIED_REDEPLOYMENT"] = "mom.accessDenied.redployment";
    ErrorCode["ACCESS_DENIED_TARGET_ORG"] = "mom.accessDenied.targetOrg";
    ErrorCode["CONFLICT_INSTANCE_DELETE"] = "mom.conflict.instanceDelete";
    ErrorCode["ENTITY_ACCESS_EXISTS"] = "mom.conflict.entityAccessExists";
    ErrorCode["SITE_NUMBER_EXISTS"] = "mom.conflict.siteNumberExists";
    ErrorCode["EXISTING_SITE_IN_ENVIRONMENT"] = "mom.conflict.workspaceSiteExistsInEnvironment";
    ErrorCode["IDENTITY_NOT_VERIFIED"] = "iam.accessDenied.unverified";
    ErrorCode["PASSWORD_STRENGTH"] = "iam.invalidArgument.passwordStrength";
    ErrorCode["PROD_ENVIRONMENT_LIMIT_REACHED"] = "mom.accessDenied.maxEnvironments";
    ErrorCode["USED_PASSWORD"] = "iam.invalidArgument.usedPassword";
})(ErrorCode || (ErrorCode = {}));
